// chi is fractal's own render: a faceless hologram girl on a crt. the picture stays as drawn,
// moods are screen effects on top (a rolling scan band, flicker, glow) so they never fight the art

export function chiSvg(): string {
  return `<img class="chi" src="assets/chi.webp" alt="" draggable="false" decoding="async" /><i class="chi-roll"></i>`;
}
